import { formatDate } from "../../../utils";
import "./DateCell.scss";
const DateCell = ({ showDiff, name, data, extraData }: any) => {
  return (
    <div className="date-cell-container">
      <div>{formatDate(data)}</div>
      {showDiff && <span> {extraData[name + "_diff"]}</span>}
    </div>
  );
};

export { DateCell };
